import Button from 'molecules/Button';
import Image from 'molecules/Image';
import Link from 'molecules/Link';

import { closeMenu } from 'layout/header/store';

import type { FC } from 'react';

const ResourceCard: FC<{
  title: string;
  summary: string;
  url: string;
  featuredImage?: { url: string; alt?: string };
  featuredVideoThumbnail?: { url: string; alt?: string };
}> = ({ title, summary, url, featuredImage, featuredVideoThumbnail }) => {
  const resourceImage = featuredImage ? featuredImage : featuredVideoThumbnail;

  return (
    <Link href={url} aria-label={title} onClick={() => closeMenu()} enablePreview={false}>
      <div className="flex flex-col items-center sm:w-full sm:flex-row xl:mt-4 xl:w-[271px] xl:flex-col">
        {resourceImage?.url && (
          <div className="aspect-video h-fit w-full overflow-hidden rounded-md xl:w-full">
            <Image url={resourceImage.url} alt={resourceImage.alt || ''} aspectRatio="16 / 9" objectCover />
          </div>
        )}
        <div className="flex w-full flex-col gap-4 py-3 sm:pl-6 xl:pl-0">
          {title && <h3 className="text-lg font-bold text-white">{title}</h3>}
          {summary && <p className="line-clamp-2 text-sm text-gray-300">{summary}</p>}
          {url && <Button label="Learn more" hierarchy="linkGray" endIcon="arrow-up-right" className="mt-1" />}
        </div>
      </div>
    </Link>
  );
};

export default ResourceCard;
